<template>
    <div class="main-header mt-5">
        <div class="header-title">
            <div class="breadcumb">
                <a id="campaign" @click="navigteToList" class=""><i class="fa fa-chevron-left"></i> Campaigns</a>
            </div>
            <!-- <h2 class="page-title">{{ campaignName }}</h2> -->
        </div>
        <!-- <div class="campaign-budget">
            <form id="form-budget">
                <div class="budget-item">
                    <p class="budget-title">Campaign Group</p>
                    <input id="campaign-group" class="budget-value value="/>
                </div>
                <div class="budget-item">
                    <p class="budget-title">Bid Strategy</p>
                    <input id="budget-bidStrategy" name="budget-bidStrategy" class="budget-value uppercase" value="" disabled/>
                </div>
                <div class="budget-item">
                    <p class="budget-title">Campaign Budget</p>
                    <input id="campaign-budget-value" name="campaign-budget-value" class="budget-value highlighted" value="" disabled/>
                </div>
            </form>
        </div> -->
    </div>
</template>

<script>
export default {
    name: 'CampaignDetailHeader',
    data() {
        return {
            campaignName:'Azo Bladder Control 54 Capsules-B00KAP0HQW-Brand',
        }
    },
    methods: {
       checkPack() {

	   },
	   navigteToList(){
		   this.$router.push({path:'/campaignList'})
	   }
    }

}
</script>

<style scoped src="@/assets/css/main.css">

</style>
